









































































































































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import store from "../store/index";

export default Vue.extend({
  name: "CheckResultDetail",
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkInfo: (state: any) => store.getters.getCheckInfo,
    productId: (state: any) => store.getters.getProductId,
  }),
  watch: {
    checkInfo(newVal, oldVal) {
      this.transformData();
    },
  },
  data() {
    return {
      maxSimilarScale: 0,
      maxSimilarNum: 0,
      maxSimilarTitle: "",
      maxTitleLink: "",
    };
  },
  methods: {
    // 跳转链接
    toUrl() {
      if (this.maxTitleLink) {
        window.open(this.maxTitleLink, "_blank");
      }
    },
    // 改造数据
    transformData() {
      const recordList = this.checkInfo.recordList1 || [];
      if (recordList.length) {
        recordList.forEach((item: any) => {
          if (
            this.maxSimilarScale === 0 &&
            this.maxSimilarNum === 0 &&
            this.maxSimilarTitle === ""
          ) {
            this.maxSimilarScale = item.copyPercent;
            this.maxSimilarNum = item.hitLength;
            this.maxSimilarTitle = item.title;
            this.maxTitleLink = item.titleLink;
          }
          if (item.copyPercent > this.maxSimilarScale) {
            this.maxSimilarScale = item.copyPercent;
            this.maxSimilarNum = item.hitLength;
            this.maxSimilarTitle = item.title;
            this.maxTitleLink = item.titleLink;
          }
        });
      } else {
        this.maxSimilarScale = 0;
        this.maxSimilarNum = 0;
        this.maxSimilarTitle = (this as any).$t("crd.no");
        this.maxTitleLink = "";
      }
    },
  },
  mounted() {
    this.transformData();
  },
});
